import React, { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { themeAlpine } from 'ag-grid-community';
import PanelAboveDashboard from './PanelAboveDashboard/PanelAboveDashboard';
import { usePagination } from './usePagination';
import { useGridConfiguration } from './useGridConfiguration';
import { useGridHandlers } from './useGridHandlers';
import { useDeselectOnFilterChange } from './useDeselectOnFilterChange';
import { useSideBarConfiguration } from './useSideBarConfiguration';
import { useResetPaginationOnMount } from './useResetPaginationOnMount';
import PaginationControls from './PaginationControls/PaginationControls';
import styles from './Dashboard.module.scss';

export const styled: React.CSSProperties = {
  fontFamily: 'Fira Sans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif',
};

const NewDashboard = () => {
  const gridReference = useRef<AgGridReact>(null);

  const {
    jobs: allJobs,
    error,
    goToPage,
    currentPage,
    totalPages,
    totalJobs,
    isError,
    isFetchingNewPage,
    isLoading,
    itemsPerPage,
    setItemsPerPage,
  } = usePagination();

  const {
    columnDefinitions,
    defaultColumnDefinition,
    autoGroupColumnDefinition,
    rowSelection,
    getRowId,
    selectionColumnDefinition,
  } = useGridConfiguration();

  const { onGridReady, onSelectionChanged, onFilterChanged } =
    useGridHandlers();

  const { sideBarConfiguration } = useSideBarConfiguration();

  useDeselectOnFilterChange();
  useResetPaginationOnMount();

  if (isError) {
    return (
      <div className={styles.error}>
        Error loading dashboard: {error?.message}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Orchestration Status</h1>
      </div>
      <PanelAboveDashboard />
      <div className={styles.gridContainer}>
        <AgGridReact
          theme={themeAlpine.withParams(styled)}
          ref={gridReference}
          rowData={allJobs}
          columnDefs={columnDefinitions}
          defaultColDef={defaultColumnDefinition}
          autoGroupColumnDef={autoGroupColumnDefinition}
          selectionColumnDef={selectionColumnDefinition}
          treeData={true}
          treeDataChildrenField="children"
          getDataPath={(data) => [data.jobId.toString()]}
          getRowId={getRowId}
          rowSelection={rowSelection}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onFilterChanged={onFilterChanged}
          cellSelection={true}
          loading={isLoading}
          groupDefaultExpanded={0}
          suppressAggFuncInHeader={true}
          enableFilterHandlers={true}
          pivotPanelShow={'onlyWhenPivoting'}
          sideBar={sideBarConfiguration}
          pagination={true}
          paginationPageSize={itemsPerPage}
          suppressPaginationPanel={true}
        />
      </div>
      <div className={styles.paginationFooter}>
        <PaginationControls
          currentPage={currentPage}
          isFetchingNewPage={isFetchingNewPage}
          isLoading={isLoading}
          itemsPerPage={itemsPerPage}
          onItemsPerPageChange={setItemsPerPage}
          onPageChange={goToPage}
          totalJobs={totalJobs}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default NewDashboard;
